import React from 'react';
import { CircularProgress } from '@mui/material';

interface CircleButton extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  ButtonText: string;
  loader?: boolean;
  onPress?: () => void;
  type?: "button" | "submit" | "reset"; // Type adjusted to possible button types
  btnExtraStyle?: React.CSSProperties; // Correct type for CSS styles;
  btnExtralClasses?: string,
  id?: string;
};
const CircleButton: React.FC<CircleButton> = ({
  ButtonText = "",
  loader = false,
  onPress = () => { },
  type = "button",
  btnExtraStyle = {},
  btnExtralClasses = "",
  id = "",
  ...extraProps // Spread any additional props
}) => {
  const loaderStyle = {
    width: 14,
    height: 14,
    color: "#fff"
  };
  return (
    <div>
      <button
        id={id}
        className={`circle-button font-size-18px hover:!bg-[#fff]  hover:text-[#00443f] font-Poppins-SemiBold capitalize ${btnExtralClasses}`}
        disabled={loader}
        onClick={onPress}
        type={type}
        style={{ ...btnExtraStyle }}
        {...extraProps} // Apply additional props
      >
        {ButtonText}

        {loader && <CircularProgress style={loaderStyle} />}
      </button>
    </div>
  );
};

export default CircleButton;